import React, { Component } from 'react'
import SearchBar from '../SearchBar';

export class DomainOffer extends Component {
    render() {
        return (
            <div className="domain-search-wrap section-padding-domain" id='feature'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-12">
                            <div className="domian-promo-main">
                                <SearchBar/>
                                
                                <div className="domain-name-price-wrap">
                                    <ul>
                                        <li><span>.com</span></li>
                                        <li><span>.net</span></li>
                                        <li><span>.tips</span></li>
                                        <li><span>.edu</span></li>
                                        <li><span>.info</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DomainOffer
